export const bannerContent = {
    ES: {
        MYR: '20%',
        SGD: '50%',
        VND: '20%',
        banner: {
            default: '096-esport-bn.webp',
            VND: '096-esport-bn_VND.webp',
        },
    },
    C: {
        en: {
            text_1: 'LIVE Casino',
            text_2: 'Brings Las Vegas',
            text_3: 'to your',
            text_4: 'Living Room',
        },
        zh: {
            text_1: '真人娱乐场',
            text_2: '把拉斯维加斯',
            text_3: '带到',
            text_4: '您的客厅',
        },
        ms: {
            text_1: 'LIVE Kasino',
            text_2: 'membawa Las Vegas',
            text_3: 'ke ruang tamu anda',
            text_4: 'anda',
        },
    },
    SL: {
        en: {
            text_1: 'NEXTSPIN SLOTS',
            text_2: 'Make your pick from',
            text_3: 'a variety of fun game',
            text_4: 'Keep it rolling and watch your bankroll grow',
            text_5: 'HABANERO',
            text_6: 'Experience sheer',
            text_7: 'gaming pleasure with world-class products',
        },
        zh: {
            text_1: '老虎机',
            text_2: '从各种有趣的游戏中',
            text_3: '选择您最爱的游戏',
            text_4: '保持滚动并观察您的资金增长',
            text_5: 'HABANERO',
            text_6: '感受世界首屈一指的游戏',
            text_7: '所激发的最纯粹优质的游戏体验',
        },
        ms: {
            text_1: 'SLOT',
            text_2: 'Pilih dari pelbagai',
            text_3: 'permainan',
            text_4: 'Terus putar dan perhatikan bankroll anda berkembang',
            text_5: 'HABANERO',
            text_6: 'Rasakan seronok tulen',
            text_7: 'dengan produk bertaraf dunia',
        },
        vi: {
            text_1: 'NEXTSPIN SLOTS',
            text_2: 'Hãy lựa chọn cho bạn',
            text_3: 'từ vô vàn trò chơi thú vị',
            text_4: '',
            text_5: 'HABANERO',
            text_6: 'Tối Đa Trải Nghiệm',
            text_7: 'Trò Chơi Giải Trí',
            text_8: 'Đẳng Cấp Thế Giới',
        },
    },
    G: {
        en: {
            text_1: 'Eyes-Catching 3D Games',
            text_2: 'Immerse in the ',
            text_3: 'Wonder World of',
            text_4: '3D',
        },
        zh: {
            text_1: '让您目不转睛的3D游戏',
            text_2: '跃入缤纷多彩的',
            text_3: '的3D世界!',
            text_4: '',
        },
        vi: {
            text_1: '3D Games Bắt Mắt',
            text_2: 'Thỏa Sức Trong',
            text_3: 'Thế Giới 3D',
            text_4: 'Diệu Kỳ',
        },
    },
    S: {
        en: {
            text_1: 'SPORTSBOOK',
            text_2: 'BEST ODDS',
            text_3: 'IN MARKET',
            text_4: 'Offers over 1500 sporting events every week',
        },
        zh: {
            text_1: 'SPORTSBOOK ',
            text_2: '市场',
            text_3: '最高赔率',
            text_4: '每周提供超过1500个体育赛事',
        },
        ms: {
            text_1: 'SPORTSBOOK',
            text_2: 'KEMUNGKINAN',
            text_3: 'TERTINGGI',
            text_4: 'Menawarkan lebih daripada 1500 acara sukan setiap minggu',
        },
        vi: {
            text_1: 'THỂ THAO',
            text_2: 'TỶ LỆ CƯỢC TỐT NHẤT',
            text_3: 'THỊ TRƯỜNG',
        },
    },
    F: {
        en: {
            text_1: "LET'S GO FISHING",
            text_2: 'The most Popular',
            text_3: 'games in town',
            text_4: 'Hunt as many fishes as you can to become the next Fishing God',
        },
        zh: {
            text_1: '一起去钓鱼吧',
            text_2: '全场最受欢迎',
            text_3: '的钓鱼游戏',
            text_4: '尽你所能捕抓最多的金钱鱼来成为下个捕鱼王',
        },
        ms: {
            text_1: 'JOM, PERGI MEMANCING',
            text_2: 'Permainan memancing',
            text_3: 'yang paling popular',
            text_4: 'Memburu sebanyak mungkin ikan untuk menjadi Dewa Memancing seterusnya',
        },
        vi: {
            text_1: 'CÙNG CHƠI BẮN CÁ',
            text_2: 'Trò chơi phổ biến nhất',
            text_3: 'khu vực',
        },
    },
    L: {
        en: {
            text_1: 'Lottery',
            text_2: 'A bigger win that you could imagine!',
        },
        zh: {
            text_1: '彩票',
            text_2: '远超您想象的丰厚奖金！',
        },
        ms: {
            text_1: 'Lottery',
            text_2: 'Kemenangan besar di luar imajinasi anda!',
        },
        vi: {
            text_1: 'XỔ SỐ',
            text_2: 'Cược nhỏ thắng lớn',
            text_3: 'chưa từng có!!',
            text_4: '',
        },
    },
    P: {
        en: {
            text_1: 'IDN POKER',
            text_2: 'Play Poker anywhere',
            text_3: 'anytime on any devices',
            text_4: 'Check out our latest Multiplayer Games and invite your friends to join you',
        },
        zh: {
            text_1: 'IDN POKER',
            text_2: '随时随地在任何',
            text_3: '设备上玩扑克',
            text_4: '查看我们最新的多人游戏，并邀请您的朋友一起来玩吧',
        },
        ms: {
            text_1: 'IDN Poker',
            text_2: 'Main Poker di mana sahaja',
            text_3: 'bila-bila masa sahaja',
            text_4: 'Lihat permainan berbilang pemain terbaru kami dan jemput rakan anda untuk bermain bersama anda',
        },
    },
    FD: {
        en: {
            text_1: '4D',
            text_2: 'Easy Big Win',
            text_3: 'with Simply Low Bet',
            text_4: '',
        },
        zh: {
            text_1: '4D',
            text_2: '小额赌注,',
            text_3: '巨额奖金',
            text_4: '',
        },
        ms: {
            text_1: '4D',
            text_2: 'Bertaruh Sikit, ',
            text_3: 'Berprofit Tinggi',
            text_4: '',
        },
        vi: {
            text_1: '4D',
            text_2: 'Easy Big Win',
            text_3: 'with Simply Low Bet',
            text_4: '',
        },
    },
    VIP: {
        en: {
            text_1: 'THE VIP LOUNGE',
            text_2: 'With Maxim88',
            text_3: 'every moment is elevated',
            text_4: 'Bigger rewards, better services await in the VIP Lounge',
        },
        zh: {
            text_1: 'VIP大厅',
            text_2: '您的每刻美好时光',
            text_3: '从Maxim88开始',
            text_4: '贵宾休息室将为您提供更多的奖励和更好的服务',
        },
        ms: {
            text_1: 'Ruang VIP',
            text_2: 'Setiap momen-mu semakin sempurna',
            text_3: 'dengan Maxim88',
            text_4: 'Ganjaran lebih besar, perkhidmatan lebih baik menanti anda di Lounge VIP',
        },
        vi: {
            text_1: 'SẢNH VIP',
            text_2: 'Với Maxim88',
            text_3: 'mỗi khoảnh khắc được nâng tầm',
            text_4: '',
        },
    },
    SCR: {
        en: {
            text_1: '150%',
            text_2: 'Welcome Bonus',
            text_3: '{percent} DAILY RELOAD BONUS',
            text_4: 'Keep Calm and Spin On',
        },
        zh: {
            text_1: '150％',
            text_2: '迎新彩金',
            text_3: '{percent}每日再存奖金',
            text_4: '保持冷静并继续旋转',
        },
        ms: {
            text_1: '150%',
            text_2: 'WELCOME BONUS',
            text_3: '{percent} BONUS RELOAD HARIAN',
            text_4: 'Tenang dan Berputar',
        },
    },
    RAFFLE: {
        en: {
            text_1: "IT'S YOUR LUCKY DAY",
            text_2: 'Play for a chance to win big!',
            text_3: 'On: PLACEHOLDER',
            date: 'Next Draw On',
        },
        zh: {
            text_1: '今天是您的幸运日',
            text_2: '立即游戏，赢取大奖',
            text_3: '抽奖日',
            date: '下个抽奖日',
        },
        ms: {
            text_1: 'TIBANYA HARI BERTUAH ANDA',
            text_2: 'Kemenangan besar anda hanya sejauh satu cabutan!',
            text_3: 'Undian Seterusnya',
            date: 'Cabutan Seterusnya',
        },
        vi: {
            text_1: 'Chúc May Mắn',
            text_2: 'Lượt Rút Thăm Maxim88',
            text_3: 'tiếp theo diễn ra vào',
        },
        'en-vn': {
            text_1: 'Good Luck',
            text_2: 'Your Next Maxim88',
            text_3: 'Draw in',
        },
    },
    CF: {
        en: {
            text_1: 'Cock Fight',
            text_2: 'Hyped you up with action!',
        },
        zh: {
            text_1: '斗鸡',
            text_2: '同享刺激与胜利！',
        },
        ms: {
            text_1: 'Sabung Ayam',
            text_2: 'Hype-kan anda dengan aksi!',
        },
        vi: {
            text_1: 'Đá Gà',
            text_2: 'Những trận đấu đỉnh cao quy tụ anh hùng Chiến Kê! Chọn gà chiến ngay!',
        },
    },
};
